import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { HeaderMenuModel,commonHeaderData,headerData } from "src/app/landing/Models/header-menu-model";
import { StorageService } from "src/app/shared/Services/storage.service";
import { Constant } from "../../shared/Constants/constant";

@Injectable()
export class landingServices {
  IsLogin: boolean = false;
  CurrentRoute: string = "";
  constructor(public storageService: StorageService, private router: Router) {
    this.IsLogin = this.storageService.isLoggedIn();
  }

  async getHeaderData(): Promise<Observable<HeaderMenuModel[]>> {
    this.CurrentRoute = await this.storageService.GetUrl();
    if (
      !this.IsLogin &&
      !Constant.ROUTE_HEADINGS_NL.some((route) =>
        this.CurrentRoute.includes(route)
      )
    ) {
      return this.getLoggedOutHeader(commonHeaderData);
    } else if (
      !this.IsLogin &&
      Constant.ROUTE_HEADINGS_NL.some((route) =>
        this.CurrentRoute.includes(route)
      )
    ) {
      return of(commonHeaderData.sort((a, b) => a.Order - b.Order));
    } else {
      return of([]);
    }
  }

  private getLoggedOutHeader(
    commonHeaderData: HeaderMenuModel[]
  ): Observable<HeaderMenuModel[]> {
    return of(headerData.sort((a, b) => a.Order - b.Order));
  }

  async showFooter(): Promise<boolean>{
    this.CurrentRoute = await this.storageService.GetUrl();
    if (
      !this.IsLogin &&
      !Constant.ROUTE_HEADINGS_NL.some((route) =>
        this.CurrentRoute.includes(route)
      )
    ) {
      return false;
    } else if (
      !this.IsLogin &&
      Constant.ROUTE_HEADINGS_NL.some((route) =>
        this.CurrentRoute.includes(route)
      )
    ) {
      return true;
    } else {
      return true;
    }
  }
}
